// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"ad1d9649","36":"e3a89c5c","234":"0bab07ce","353":"03d606f0","406":"a1cd1fae","762":"41716630","785":"ff96c387","882":"ad1d9649"}[chunkId] + ".chunk.css";
};